export default __webpack_public_path__ + "static/media/ConstantWorkImg.b5507ad7.jpg";